import EventEmitter from 'event-emitter-es6';

const EVENTS_RESIZE = 'vpbank.resize';

/**
 * TODO: Document
 */
export default class Events extends EventEmitter {
  static get RESIZE() {
    return EVENTS_RESIZE;
  }
}
